import { Internals } from "remotion";

/**
 * Whether the Player is holding its timeline for a layer that is still
 * loading. Always false while rendering, where nothing blocks playback.
 *
 * Remotion keeps the buffering flag on its timeline context and exposes it only
 * through this internal hook.
 */
export function usePlayerBuffering(): boolean {
  return Internals.useBuffering();
}
